<section class="card-section me-5 ms-3">
  <div class="cards-container">
    <mat-card class="card-balance" appearance="outlined">
      <mat-card-content>
        <div>
          <div class="d-flex justify-content-between">
            <span class="card-info">{{ 'activity.balance' | translate }}</span>
            @if (isRequestPaymentEnabled()) {
                              <a class="request-payment cursor-pointer" (click)="openRequestPaymentDialog()">{{ 'activity.request_payment' | translate }}</a>
            }
          </div>
          <div class="balance-amount">
            <span class="amount">{{ BalanceFormatterUtil.getFormattedBalance(balance) }}</span>
            <span class="currency">&#1423;</span>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="credit-card" appearance="outlined">
      <mat-card-content>
        <div class="credit-card-container">
          <div>
            <span class="card-info d-flex align-items-start">{{ 'activity.bank_account' | translate }}<span
              class="material-icons-outlined fs-6 cursor-pointer ms-3"
              (click)="openCreditCardsDialog()">edit</span> </span>
            <span>********{{ lastFourNumbers ? lastFourNumbers : '0000' }}</span>
          </div>
          <div class="width-55 d-flex justify-content-end">
            <img class="border-radius-4" src="../../assets/svg/blue-payments.svg" alt="Visa">
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="web-team-transactions-status">
    <div class="d-flex flex-direction-column gap-10px">
      <div class="text-end">
      <span class="team-transactions-status">
        @if (activeTab === ActivityTabs.MY_TEAM) {
          {{ currentTeam.requestAllowed ? ('team_transactions.on' | translate) : ('team_transactions.off' | translate) }}
        } @else if (activeTab === ActivityTabs.ALL_TEAMS && selectedTeam) {
          {{ selectedTeam.requestAllowed ? ('team_transactions.on' | translate) : ('team_transactions.off' | translate) }}
        }
      </span>
      </div>
    </div>
  </div>
</section>
<section class="card-section me-5 ms-3 mt-2">
  <div class="cards-container">
  </div>
  <div class="d-flex flex-direction-column gap-10px">
    <div class="toggle-container">
      <button class="toggle-button" [class.active]="activeTab === ActivityTabs.ALL_INDIVIDUAL"
              (click)="toggleIndividual(ActivityTabs.ALL_INDIVIDUAL)">
        <img src="assets/svg/person_16.svg" alt="">
        <span class="mx-2">{{ 'activity.individual' | translate }}</span>
      </button>
      @if (currentTeam) {
        <button class="toggle-button" [class.active]="activeTab === ActivityTabs.MY_TEAM"
                (click)="toggleIndividual(ActivityTabs.MY_TEAM)">
          <img src="assets/svg/shield_person.svg" alt="">
                      <span class="mx-2">{{ 'my_team.my_team' | translate }}</span>
        </button>
      }
      @if (teams.length) {
        <button class="toggle-button" [matMenuTriggerFor]="menu" [class.active]="activeTab === ActivityTabs.ALL_TEAMS"
                (click)="toggleIndividual(ActivityTabs.ALL_TEAMS)">
          <img src="assets/svg/group.svg" alt="">
          <span class="mx-2">{{ 'activity.all_teams' | translate }}</span>
          @if (!isMenuOpen) {
            <img src="assets/svg/arrow_drop_down.svg" alt="down svg">
          } @else {
            <img src="assets/svg/arrow_drop_up.svg" alt="up svg">
          }
        </button>
        <mat-menu #menu="matMenu">
          @for (team of teams; track team) {
            <button mat-menu-item [ngClass]="{ 'selected': selectedTeamId == team.id }"
                    (click)="selectTeam(team)">
              {{ (team.name == SharedConstants.MY_TEAM && team.id != currentTeam.id) ? SharedConstants.TEAM + ' ' + team.id : team.name }}
              @if (team.id == currentTeam.id) {
                <span>(Owner)</span>
              }
            </button>
          }
        </mat-menu>
      }
    </div>
  </div>
</section>
<div class="mobile-team-transactions-status">
  <div class="d-flex flex-direction-column gap-10px mt-3 me-3">
    <div class="text-end">
      <span class="team-transactions-status">
        @if (activeTab === ActivityTabs.MY_TEAM) {
          {{ currentTeam.requestAllowed ? ('team_transactions.on' | translate) : ('team_transactions.off' | translate) }}
        } @else if (activeTab === ActivityTabs.ALL_TEAMS && selectedTeam) {
          {{ selectedTeam.requestAllowed ? ('team_transactions.on' | translate) : ('team_transactions.off' | translate) }}
        }
      </span>
    </div>
  </div>
</div>
<mat-card class="mt-4 custom-card me-5 ms-3">
  <mat-card-content class="mt-4">
    @if (activeTab === ActivityTabs.MY_TEAM && !currentTeam.requestAllowed) {
      <div class="no-data-container">
        <img src="assets/svg/no_data.svg" alt="down svg">
        <h2>Data is Not Available</h2>
        <span>You have chosen not to track team <br> member transactions.</span>
      </div>
    } @else {
      <div class="transaction-toolbar">
        <div class="transaction-tabs">
          <button [class.active]="selectedTab === SharedConstants.ALL" (click)="resetTransactions(); selectTab(SharedConstants.ALL)">{{ 'activity.all_transactions' | translate }}
          </button>
          <button [class.active]="selectedTab === SharedConstants.INCOMING"
                  (click)="resetTransactions(); selectTab(SharedConstants.INCOMING); changeTransactionsIsSeen()">{{ 'activity.incoming' | translate }}
            @if (isNewTransactions) {
              <img class="ms-2" src="assets/svg/dot.svg">
            }
          </button>
          <button [class.active]="selectedTab === SharedConstants.BALANCE_TRANSFER"
                  (click)="resetTransactions(); selectTab(SharedConstants.BALANCE_TRANSFER)">
            {{ 'activity.balance_withdrawal' | translate }}
          </button>
        </div>

        <div class="search-filter-section">
          @if (selectedTab !== SharedConstants.BALANCE_TRANSFER) {
            <div class="search-bar">
              <mat-icon>search</mat-icon>
              <input type="text" [(ngModel)]="searchQuery" (input)="search()" placeholder="{{ 'activity.search_transaction' | translate }}"/>
            </div>
          }
          <button [matMenuTriggerFor]="filterMenu" class="filter-button"
                  [ngClass]="{ 'background-change': menuOpen }"
                  [attr.lang]="currentLang"
                  (menuOpened)="onMenuOpened()"
                  (menuClosed)="onMenuClosed()"
                  [disabled]="hasNoData">
            <mat-icon class="mx-1">filter_list</mat-icon>
            @if (menuOpen) {
              {{ 'filter_button_text' | translate }}
            }
          </button>
          <mat-menu #filterMenu="matMenu">
            <div class="close-button trigger_class_for_activity_menu" (click)="filterMenu.close">
              <img src="assets/svg/closeButton.svg">
            </div>
            <div [formGroup]="filterForm">
              <div class="modal-header">
                <h2>{{ 'activity.filter_by' | translate }}</h2>
              </div>
              <div class="modal-body">
                <div class="row">
                  @if (filterForm.hasError('amountInvalid')){
                    <mat-error>
                      <small>'To' must be greater than or equal to 'From'</small>
                    </mat-error>
                  }
                  <mat-form-field class="col-12 col-lg-6 col-md-12 col-sm-12" (click)="$event.stopPropagation()">
                    <input matInput formControlName="amountFrom" type="number"
                           (keypress)="allowOnlyNumbers($event)" placeholder="{{ 'activity.amount_from' | translate }}"/>
                  </mat-form-field>
                  <mat-form-field class="col-12 col-lg-6 col-md-12 col-sm-12" (click)="$event.stopPropagation()">
                    <input matInput formControlName="amountTo" type="number"
                           (keypress)="allowOnlyNumbers($event)" placeholder="{{ 'activity.amount_to' | translate }}"/>
                  </mat-form-field>
                  @if (filterForm.get('dateRange.startDate')?.invalid || filterForm.get('dateRange.endDate')?.invalid) {
                    <mat-error>
                      <small>Invalid date format</small>
                    </mat-error>
                  }
                  <mat-form-field (click)="$event.stopPropagation(); picker.open()">
                    <mat-label>{{ 'activity.date' | translate }}</mat-label>
                    <mat-date-range-input formGroupName="dateRange" [rangePicker]="picker">
                      <input matStartDate formControlName="startDate" placeholder="Start date">
                      <input matEndDate formControlName="endDate" placeholder="End date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker>
                      <mat-date-range-picker-actions>
                        <button mat-button class="button-size-16" (click)="resetDateRange(picker)">{{ 'activity.reset' | translate }}</button>
                        <button mat-button class="button-size-16" matDateRangePickerApply>{{ 'activity.ok' | translate }}</button>
                      </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>
                  @if (selectedTab == SharedConstants.BALANCE_TRANSFER) {
                    <mat-form-field class="col-md-12 new-style" appearance="fill" (click)="$event.stopPropagation()">
                      <mat-select [placeholder]="'select_credit_card' | translate" formControlName="status">
                        <mat-option [value]="SharedConstants.REJECTED">
                          {{ 'payment_status.rejected' | translate }}
                        </mat-option>
                        <mat-option [value]="SharedConstants.COMPLETED">
                          {{ 'payment_status.completed' | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  }
                </div>
              </div>
              <div class="modal-actions">
                <button class="cancel-button option-shared" (click)="resetTransactions(); reset()">{{ 'activity.reset_filter' | translate }}</button>
                <button class="request-button option-shared btn" [disabled]="hasNoData || !filterForm.dirty"
                        (click)="resetTransactions(); filter()">{{ 'activity.filter' | translate }}
                </button>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
      <p-table class="transaction-table mt-5" [value]="uniquePaymentTransactions"
               [tableStyle]="{'min-width': '60rem'}"
               [paginator]="false"
               [rowHover]="true"
               [resizableColumns]="true"
               [sortOrder]="-1">
        <ng-template pTemplate="header">
          <tr>
            <th class="bg-light-white" pResizableColumn pSortableColumn="createdTimestamp">{{ 'activity.date_time' | translate }}
              <p-sortIcon field="createdTimestamp"></p-sortIcon>
            </th>
            <th class="bg-light-white" pResizableColumn>{{ 'activity.transaction_type' | translate }}</th>
            <th class="bg-light-blue" pResizableColumn pSortableColumn="fromUser.name">{{ 'activity.from' | translate }}
              <p-sortIcon field="fromUser.name"></p-sortIcon>
            </th>
            @if (selectedTab != SharedConstants.INCOMING) {
              <th class="bg-light-white" pResizableColumn>{{ 'activity.to' | translate }}
              </th>
            }
            <th class="bg-light-white" pResizableColumn pSortableColumn="amount">{{ 'activity.amount' | translate }}
              <p-sortIcon field="amount"></p-sortIcon>
            </th>
            @if (selectedTab !== SharedConstants.BALANCE_TRANSFER) {
              <th class="bg-light-white" pResizableColumn pSortableColumn="commission">{{ 'activity.commission' | translate }}
                <p-sortIcon field="commission"></p-sortIcon>
              </th>
            }
            <th class="bg-light-white" pResizableColumn pSortableColumn="paymentStatus">{{ 'activity.status' | translate }}
              @if (selectedTab != SharedConstants.INCOMING) {
                <p-sortIcon field=""></p-sortIcon>
              }
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <div class="date-time-container">
                <div class="date-time-header">
                  <span class="table-card-label">Date & Time</span>
                  @if (row.paymentStatus === SharedConstants.PENDING) {
                    <span class="status-icon pending">
                      <img src="assets/svg/clock_loader_60.svg" alt="Pending">
                    </span>
                  } @else if (row.paymentStatus === SharedConstants.REJECTED) {
                    <span class="status-icon failed">
                      <mat-icon>cancel</mat-icon>
                    </span>
                  } @else {
                    <span class="status-icon success">
                      <mat-icon>check_circle</mat-icon>
                    </span>
                  }
                </div>
                <div class="date-time-value">
                  {{ row.createdTimestamp | date: 'dd.MM.yyyy' }}<br>
                  {{ row.createdTimestamp | date: 'HH:mm' }}
                </div>
              </div>
            </td>
            <td>
             <span><span class="table-card-label">Transaction Type<br></span>
               {{ row.paymentMethod | titlecase }}
             </span>
            </td>
            <td class="bg-light-blue">
             <span class="cursor-pointer">
               <span class="table-card-label">From<br></span>
               @if (row.fromUser) {
                 {{ row.fromUser.name + " " + row.fromUser.surname }}
                 @if (row.fromUser.id === currentUser.id) {
                   (Me)
                 }
               } @else if (row.buyer) {
                 {{ row.buyer }}
               } @else {
                 -
               }
             </span>
            </td>
            @if (selectedTab != SharedConstants.INCOMING) {
              <td>
             <span class="cursor-pointer">
               <span class="table-card-label">To<br></span>
               @if (row.toUser) {
                 {{ row.toUser.name + " " + row.toUser.surname }}
               } @else if (row.bankCard) {
                 {{ row.bankCard.cardholderName }} <br>
                 ******** {{ getLastFourDigits(row.bankCard.accountNumber) }}
               } @else {
                 -
               }
             </span>
              </td>
            }
            <td>
             <span><span class="table-card-label">Amount (AMD)<br></span>
               {{ row.paymentMethod == SharedConstants.TRANSFER || !row.paymentMethod ? '-' : '+' }}
               {{ BalanceFormatterUtil.getFormattedBalance(calculateAmount(row)) }} {{ currency }}
             </span>
            </td>
            @if (selectedTab !== SharedConstants.BALANCE_TRANSFER) {
              <td>
              <span><span class="table-card-label">Commission<br></span>
                    <span *ngIf="row.paymentMethod !== SharedConstants.TRANSFER; else noCommission">
                      {{ BalanceFormatterUtil.getFormattedBalance(calculateCommission(row.amount, row.commission, row.userCardCommission, row.commissionUnit, row.standardCommission)) }} {{ getCommissionSymbol(row.commissionUnit) }}
                    </span>
                <ng-template #noCommission>-</ng-template>
             </span>
              </td>
            }
            <td class="actions">
              @if (row.paymentStatus == SharedConstants.PENDING) {
                <span class="status-icon pending"><img src="assets/svg/clock_loader_60.svg"></span>
              } @else if (row.paymentStatus == SharedConstants.REJECTED) {
                <span class="status-icon failed"><mat-icon class="ms-0">cancel</mat-icon></span>
              } @else {
                <span class="status-icon success"><mat-icon class="ms-0">check_circle</mat-icon></span>
              }</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="no-data">{{ 'activity.no_data_to_display' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
      @if ((currentPage < totalPages - 1) && allPaymentTransactions.length) {
        <div class="d-flex justify-content-center mt-4 flex-direction-row gap-10px">
          @if (!isLoading) {
            <button class="load-history-button">{{ 'my_team.load_more' | translate }}</button>

            <div class="search-loader">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          }
        </div>
      }
    }
  </mat-card-content>
</mat-card>
<div class="common-footer">
  <mat-card class="mobile-card-balance" appearance="outlined">
    <mat-card-content>
      <div>
        <div class="d-flex justify-content-between">
          <span class="card-info">{{ 'activity.balance' | translate }}</span>
          @if (isRequestPaymentEnabled() || ActivityFactory.isIndividualActiveInSight.value) {
                          <span class="request-payment cursor-pointer" (click)="openRequestPaymentDialog()">{{ 'activity.request_payment' | translate }}</span>
          }
        </div>
        <div class="balance-amount">
          <span class="amount">{{ BalanceFormatterUtil.getFormattedBalance(balance) }}</span>
          <span class="currency">&#1423;</span>
        </div>

      </div>
    </mat-card-content>
  </mat-card>
  @if (!lastFourNumbers){
    <button (click)="openAddCreditCardDialog()"
            class="mt-3 credit-card-button mobile-button tall-button gap-10px d-flex align-items-center">
      <img src="assets/payment-type/credit-card.svg" alt="Credit Card" class="credit-card-button-icon">
      {{ 'activity.add_bank_account_modal.title' | translate }}
      <mat-icon class="align-end">add</mat-icon>
    </button>
  } @else {
    <mat-card class="footer-credit-card mt-3" appearance="outlined">
      <mat-card-content>
        <div class="credit-card-container mb-0">
          <div>
            <span class="card-info d-flex align-items-start">{{ 'activity.bank_account' | translate }}<span
              class="material-icons-outlined fs-6 cursor-pointer ms-3"
              (click)="openCreditCardsDialog()">edit</span> </span>
            <span>********{{ lastFourNumbers ? lastFourNumbers : '0000' }}</span>
          </div>
          <div class="width-55 d-flex justify-content-end">
            <img class="border-radius-4" src="../../assets/svg/blue-payments.svg" alt="Visa">
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>

